import {createApp} from 'vue'
import Store from 'store'
import ProductGrid from './ProductGrid'

const component = createApp(ProductGrid).use(Store)

const setDataFromPage = (pageData) => {
    const data = JSON.parse(pageData.textContent)
    const mappingObject = {
        categoryGuid : data.categoryGuid || "",
        customerNumber : data.customerNumber || null,
        newsCategories : data.newsCategories || [],
        outletCategories: data.newsCategories || []
    }
    Store.commit('productSearch/setPageData', mappingObject)
}

const el = '.nlx-component--product-grid'
const DOM = document.querySelector(el)

if(DOM){
    const pageData = document.querySelector('.nlx-js--page-data')
    if (pageData) setDataFromPage(pageData)
    
    Store.dispatch('productSearch/getFilterDisplaynames')
    Store.dispatch('productSearch/setSortingOptions',DOM)
    Store.commit('main/set_ambience_toggle',DOM.dataset.ambiencetoggle)
    Store.commit('main/set_page_filters',DOM.dataset.pagefilters)
    component.mount(el)
}

